import React from 'react';
import { Quote } from 'lucide-react';
import { useSection } from '../contexts/ContentContext';
import { useReveal } from '../utils/useReveal';

const DEFAULT_TESTIMONIALS = [
  {
    quote:
      'Wearing my Silk & Sentiment lehenga felt like inheriting a whispered story. Every zardozi stitch carried the atelier\u2019s devotion \u2014 I have never felt more seen on my wedding day.',
    name: 'Aisha Malhotra',
    attribution: 'Bridal Commission, Jaipur',
  },
  {
    quote:
      'An heirloom in the truest sense. The ivory chikankari on my mother\u2019s anarkali is exactly as I imagined, only finer. The atelier listens as much as it creates.',
    name: 'Ananya Bhatt',
    attribution: 'Heritage Couture, London',
  },
  {
    quote:
      'From the first WhatsApp message to the handwritten note tucked inside the heritage box \u2014 every touchpoint felt considered. This is couture with a conscience.',
    name: 'Sara Qureshi',
    attribution: 'Reception Saree, Dubai',
  },
];

const Testimonials = () => {
  const data = useSection('home.testimonials', {
    eyebrow: 'In Their Words',
    title: 'Voices of the Atelier',
    description:
      'A few treasured words from the patrons who have carried our craft into their most meaningful occasions.',
    items: DEFAULT_TESTIMONIALS,
  });

  const items = (data.items && data.items.length ? data.items : DEFAULT_TESTIMONIALS)
    .filter((t) => t && (t.quote || '').trim())
    .slice(0, 3);
  const [ref, revealed] = useReveal();

  if (!items.length) return null;

  return (
    <section
      id="testimonials"
      className={`testimonials-section ${revealed ? 'is-revealed' : ''}`}
      ref={ref}
      data-testid="testimonials-section"
    >
      <div className="luxury-container">
        <div className="testimonials-header">
          <p className="testimonials-eyebrow">{data.eyebrow}</p>
          <h2 className="heading-1">{data.title}</h2>
          <span className="testimonials-divider" aria-hidden="true">&#10022;</span>
          <p className="body-large testimonials-description">{data.description}</p>
        </div>

        <div className="testimonials-grid" data-testid="testimonials-grid">
          {items.map((t, i) => (
            <blockquote
              key={i}
              className="testimonial-card"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="testimonial-quote-mark" size={28} strokeWidth={1} aria-hidden="true" />
              <p className="testimonial-quote">{t.quote}</p>
              <footer className="testimonial-meta">
                <span className="testimonial-rule" aria-hidden="true" />
                <cite className="testimonial-name">{t.name}</cite>
                {t.attribution && (
                  <span className="testimonial-attribution">{t.attribution}</span>
                )}
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
